import { App, Button } from 'antd';

export const DESK_MODE_OPTIONS = [
    { value: 'u_shape', label: 'U型桌' },
    { value: 'school_desk', label: '课桌' },
    { value: 'long_table', label: '长条桌' },
];

const DESK_MODE_RULES = {
    u_shape: {
        title: 'U型桌',
        items: ['1号位（最高领导/首席专家位）：坐在U型底边的正中心，面对开口处。', '2号和3号位左右（次要领导/核心贵宾/授课专家）：坐在1号位左右两侧，先左再右。', '剩余席位：按职称/学术资历顺时针依次均匀排布，沿两翼向开口处延伸。'],
    },
    school_desk: {
        title: '课桌',
        items: [
            '单数形式：1号位居中，2号位在1号位左手边，3号位在1号位的右手边。',
            '双数形式：1号位和2号位并列居中（1号在左，2号在右），3号在1号左手边，4号在2号右手边。',
            '剩余席位向左右两侧依次按职级递减排布。',
            '严格遵循医疗学术排序优先级：院士/资深特邀专家＞大会主席＞执行主席＞授课专家＞院方领导。',
            '单数、双数席位严格遵循学术排序规则，严禁随意调换位次。',
            '严禁从端头开始摆放，必须从中间向两边依次排布。',
        ],
    },
    long_table: {
        title: '长条桌',
        items: [
            '绝对对等原则：双方的“1号位”必须正对坐。双方团队按照职级，呈镜像对称排布。',
            '单数人：1号位居中，2号位在1号位左手边，3号位在1号位的右手边。',
            '双数人：1号位和2号位并列居中（1号在左，2号在右），3号在1号左手边，4号在2号右手边。',
            '“以门为尊”原则：主方（东道主/医院方/院方领导等）背对正门或背对窗户落座；客方（资深特邀专家团队/合作科研院所/医药代表等）面对正门或面向景观好的一侧落座。',
            '“内紧外疏”原则：核心决策者居中对坐，职级递减的随行人员向两端（或向后排）延伸。',
        ],
    },
};

export function formatDeskModeRuleText(deskMode) {
    const rule = DESK_MODE_RULES[deskMode];
    if (!rule) {
        return '';
    }

    return [`排座模式：${rule.title}`, '排座规则：', ...rule.items.map(item => `• ${item}`)].join('\n');
}

function fallbackCopyTextToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.width = '2em';
    textarea.style.height = '2em';
    textarea.style.padding = '0';
    textarea.style.border = 'none';
    textarea.style.outline = 'none';
    textarea.style.boxShadow = 'none';
    textarea.style.background = 'transparent';
    textarea.style.opacity = '0';
    textarea.setAttribute('readonly', '');
    const drawerContainer = document.querySelector('.seating-arrangement-drawer .ant-drawer-content') || document.body;
    drawerContainer.appendChild(textarea);

    let successful = false;
    try {
        textarea.focus();
        textarea.select();
        textarea.setSelectionRange(0, text.length);
        successful = document.execCommand('copy');
    } catch (err) {
        console.error('execCommand 复制错误:', err);
    } finally {
        drawerContainer.removeChild(textarea);
    }
    return successful;
}

export function DeskModeRuleCopyButton({ deskMode }) {
    const { message: messageApi } = App.useApp();

    if (!deskMode || !DESK_MODE_RULES[deskMode]) {
        return null;
    }

    const handleCopyRule = async () => {
        const textContent = formatDeskModeRuleText(deskMode);
        if (!textContent) {
            return;
        }

        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(textContent);
                messageApi.success('排座规则已复制');
                return;
            }
        } catch (err) {
            console.warn('Clipboard API 复制失败，降级使用 execCommand：', err);
        }

        if (fallbackCopyTextToClipboard(textContent)) {
            messageApi.success('排座规则已复制');
        } else {
            messageApi.error('复制失败，请检查浏览器权限或手动复制');
        }
    };

    return (
        <Button size="small" className="seating-desk-mode__copy" onClick={handleCopyRule}>
            复制排座信息
        </Button>
    );
}

export function DeskModeRuleContent({ deskMode, expertCount }) {
    if (!deskMode) {
        return <div className="desk-mode-rule-empty">尚未配置排座模式</div>;
    }

    const rule = DESK_MODE_RULES[deskMode];
    if (!rule) {
        return <div className="desk-mode-rule-empty">尚未配置排座模式</div>;
    }

    // 课桌和长条桶区分单数/双数，u_shape 不区分
    const hasParity = deskMode === 'school_desk' || deskMode === 'long_table';
    const parityLabel = hasParity && expertCount > 0 ? <span className="desk-mode-parity-label">（{expertCount % 2 === 1 ? '单数' : '双数'}）</span> : null;

    return (
        <div className="desk-mode-rule-content">
            <div className="desk-mode-rule-title">
                排座模式：{rule.title}
                {parityLabel}
            </div>
            <div className="desk-mode-rule-subtitle">排座规则：</div>
            <ul className="desk-mode-rule-list">
                {rule.items.map(item => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        </div>
    );
}
